import NotificationPart from "localization/base/pages/rdevNotifications/NotificationPart";

const notificationType: NotificationPart = {
  internetOutage: 'Výpadek internetu',
  osVersionChanged: 'Změna verze operačního systému',
  rdevVersionChanged: 'Změna verze RDev'
};

export default notificationType;
